import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Check, ArrowRight, CreditCard, Clock, Zap, Layers } from 'lucide-react';
export const Pricing = () => {
  return <div className="bg-black text-white min-h-screen font-sans" data-id="element-677">
      <Navbar data-id="element-678" />
      <main data-id="element-679">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-b from-black via-zinc-950 to-zinc-900 py-24 lg:py-32" data-id="element-680">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.05)_0,_transparent_70%)]" data-id="element-681"></div>
          <div className="absolute inset-0 bg-[linear-gradient(to_right,_rgba(255,255,255,0.01)_1px,_transparent_1px),_linear-gradient(to_bottom,_rgba(255,255,255,0.01)_1px,_transparent_1px)] bg-[size:40px_40px]" data-id="element-682"></div>
          {/* Decorative elements */}
          <div className="absolute top-20 left-10 w-64 h-64 bg-white/5 rounded-full filter blur-3xl" data-id="element-683"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-zinc-800/20 rounded-full filter blur-3xl" data-id="element-684"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-685">
            <div className="max-w-4xl mx-auto text-center" data-id="element-686">
              <div className="inline-block px-4 py-1 bg-white/5 backdrop-blur-sm rounded-full border border-white/10 mb-6" data-id="element-687">
                <span className="font-['Playfair_Display'] text-zinc-400 text-sm tracking-wider" data-id="element-688">
                  TRANSPARENT PRICING
                </span>
              </div>
              <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-light mb-8 leading-tight" data-id="element-689">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-zinc-400" data-id="element-690">
                  Pricing
                </span>
              </h1>
              <p className="font-['Space_Grotesk'] text-zinc-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-691">
                Simple, AI-based pricing designed to scale with your firm's
                needs and integrate with your existing processes.
              </p>
            </div>
          </div>
        </section>
        {/* Main Content */}
        <section className="relative py-20" data-id="element-692">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(255,255,255,0.02)_0,_transparent_50%)]" data-id="element-693"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-694">
            <div className="max-w-4xl mx-auto" data-id="element-695">
              {/* Introduction Section */}
              <div className="mb-24 relative" data-id="element-696">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-697"></div>
                <div className="bg-gradient-to-br from-zinc-900/80 to-black/80 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-698">
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light mb-8" data-id="element-699">
                    Simple <span className="text-white" data-id="element-700">Usage-Based Model</span>
                  </h2>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-701">
                    We've designed our pricing to be straightforward and
                    transparent, with a simple per-conversation model that
                    scales with your usage, whether your intake is managed
                    in-house or by a call center.
                  </p>
                  <p className="font-['Space_Grotesk'] text-zinc-300 text-lg mb-6 leading-relaxed" data-id="element-702">
                    Our pricing is channel-agnostic — it doesn't matter whether
                    AI conversations come through your website, phone calls, or
                    message conversations.
                  </p>
                  <div className="grid md:grid-cols-2 gap-6 mt-10" data-id="element-703">
                    <div className="bg-black/40 p-6 rounded-sm" data-id="element-704">
                      <div className="flex items-center mb-4" data-id="element-705">
                        <CreditCard size={24} className="text-white mr-3" data-id="element-706" />
                        <h3 className="font-['Playfair_Display'] text-xl" data-id="element-707">
                          AI Conversations
                        </h3>
                      </div>
                      <p className="text-white font-['Playfair_Display'] text-lg font-semibold mt-1" data-id="element-708">
                        $2 per AI conversation
                      </p>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm mt-2" data-id="element-709">
                        Whether AI is talking to a client or interacting with
                        3rd party software on your behalf.
                      </p>
                    </div>
                    <div className="bg-black/40 p-6 rounded-sm" data-id="element-710">
                      <div className="flex items-center mb-4" data-id="element-711">
                        <Clock size={24} className="text-white mr-3" data-id="element-712" />
                        <h3 className="font-['Playfair_Display'] text-xl" data-id="element-713">
                          High Volume Discount
                        </h3>
                      </div>
                      <p className="text-white font-['Playfair_Display'] text-lg font-semibold" data-id="element-714">
                        $1 per conversation
                      </p>
                      <p className="text-zinc-400 font-['Playfair_Display'] text-sm mt-2" data-id="element-715">
                        For any conversations beyond 10,000 each month.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Subscription Section */}
              <div className="mb-24 relative" data-id="element-716">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-717"></div>
                <div className="flex items-center mb-8" data-id="element-718">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-719">
                    <CreditCard size={24} className="text-white" data-id="element-720" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-721">
                    Core <span className="text-white" data-id="element-722">Offering</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-723">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-724">
                    <div className="inline-block px-4 py-1 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6" data-id="element-725">
                      <span className="font-['Playfair_Display'] text-white text-sm tracking-wider" data-id="element-726">
                        MINIMUM MONTHLY COMMITMENT
                      </span>
                    </div>
                    <div className="flex flex-col md:flex-row md:items-end gap-8 mb-10" data-id="element-727">
                      <div data-id="element-728">
                        <p className="text-zinc-400 font-['Playfair_Display'] text-sm mb-2" data-id="element-729">
                          Monthly minimum
                        </p>
                        <div className="flex items-baseline" data-id="element-730">
                          <span className="font-['Playfair_Display'] text-5xl font-light text-white" data-id="element-731">
                            $500
                          </span>
                          <span className="text-zinc-400 font-['Playfair_Display'] ml-2" data-id="element-732">
                            /month
                          </span>
                        </div>
                        <p className="text-zinc-300 font-['Playfair_Display'] text-sm mt-2" data-id="element-733">
                          Includes 250 AI conversations
                        </p>
                        <p className="text-zinc-300 font-['Playfair_Display'] text-sm mt-1" data-id="element-734">
                          +$2 per conversation for #250-9,999
                        </p>
                        <p className="text-zinc-300 font-['Playfair_Display'] text-sm mt-1" data-id="element-735">
                          $1 per conversation for 10,000+
                        </p>
                      </div>
                    </div>
                    <div className="border-t border-white/10 pt-6 mt-6" data-id="element-736">
                      <p className="text-zinc-300 font-['Playfair_Display'] text-lg mb-4" data-id="element-737">
                        No long-term commitments or contracts required.
                      </p>
                      <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center mt-4" data-id="element-738">
                        Get Started
                        <ArrowRight size={18} className="ml-2" data-id="element-739" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* Conversations Defined Section */}
              <div className="mb-24 relative" data-id="element-740">
                <div className="absolute -left-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-741"></div>
                <div className="flex items-center mb-8" data-id="element-742">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-743">
                    <Layers size={24} className="text-white" data-id="element-744" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-745">
                    Conversations <span className="text-white" data-id="element-746">Defined</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-747">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-748">
                    <p className="font-['Playfair_Display'] text-zinc-300 text-lg mb-8" data-id="element-749">
                      An AI conversation is counted as any of the following:
                    </p>
                    <div className="grid md:grid-cols-2 gap-6" data-id="element-750">
                      <div className="flex" data-id="element-751">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-752">
                          <Check size={16} className="text-white" data-id="element-753" />
                        </div>
                        <div data-id="element-754">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-755">
                            AI Phone Call
                          </h3>
                          <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-756">
                            One complete AI phone call with a lead
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-757">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-758">
                          <Check size={16} className="text-white" data-id="element-759" />
                        </div>
                        <div data-id="element-760">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-761">
                            AI Webchat
                          </h3>
                          <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-762">
                            Webchat conversations with 5+ messages or if contact
                            information is collected
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-763">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-764">
                          <Check size={16} className="text-white" data-id="element-765" />
                        </div>
                        <div data-id="element-766">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-767">
                            AI SMS Conversation
                          </h3>
                          <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-768">
                            One AI SMS conversation from a phone number (up to
                            100 messages)
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-769">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-770">
                          <Check size={16} className="text-white" data-id="element-771" />
                        </div>
                        <div data-id="element-772">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-773">
                            Email Notification
                          </h3>
                          <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-774">
                            One email notification to a member of your staff
                          </p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-775">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center mr-4" data-id="element-776">
                          <Check size={16} className="text-white" data-id="element-777" />
                        </div>
                        <div data-id="element-778">
                          <h3 className="font-['Playfair_Display'] text-lg mb-2" data-id="element-779">
                            Integration Call
                          </h3>
                          <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-780">
                            One integration call with 3rd party software (e.g.,
                            put the transcript into your CMS)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Premium Section */}
              <div className="mb-24 relative" data-id="element-781">
                <div className="absolute -right-20 top-0 w-40 h-40 bg-white/5 rounded-full filter blur-3xl -z-10" data-id="element-782"></div>
                <div className="flex items-center mb-8" data-id="element-783">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/5 mr-4" data-id="element-784">
                    <Zap size={24} className="text-white" data-id="element-785" />
                  </div>
                  <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-light" data-id="element-786">
                    Premium <span className="text-white" data-id="element-787">Options</span>
                  </h2>
                </div>
                <div className="ml-16" data-id="element-788">
                  <div className="bg-gradient-to-br from-zinc-900/70 to-black/70 p-8 rounded-sm border border-white/10 backdrop-blur-sm" data-id="element-789">
                    <p className="font-['Playfair_Display'] text-zinc-300 text-lg mb-8" data-id="element-790">
                      Enhance your experience with premium add-ons tailored to
                      how your firm works:
                    </p>
                    <div className="grid md:grid-cols-3 gap-6" data-id="element-791">
                      <div className="bg-black/40 p-6 rounded-sm" data-id="element-792">
                        <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-793">
                          Split Testing
                        </h3>
                        <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-794">
                          Compare performance metrics to optimize your client
                          acquisition strategy.
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm" data-id="element-795">
                        <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-796">
                          Integrations
                        </h3>
                        <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-797">
                          Connect with your existing software to streamline your
                          workflow and eliminate manual data entry.
                        </p>
                      </div>
                      <div className="bg-black/40 p-6 rounded-sm" data-id="element-798">
                        <h3 className="font-['Playfair_Display'] text-xl mb-4" data-id="element-799">
                          Custom Development
                        </h3>
                        <p className="text-zinc-400 font-['Playfair_Display'] text-sm" data-id="element-800">
                          Tailored AI solutions designed specifically for your
                          firm's unique requirements and workflows.
                        </p>
                      </div>
                    </div>
                    <div className="mt-8 text-center" data-id="element-801">
                      <p className="text-zinc-300 font-['Playfair_Display'] mb-6" data-id="element-802">
                        Contact us to discuss premium options and custom pricing
                        for your firm.
                      </p>
                      <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-6 py-3 rounded-sm hover:bg-zinc-200 transition-colors inline-flex items-center" data-id="element-803">
                        Schedule a Consultation
                        <ArrowRight size={18} className="ml-2" data-id="element-804" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-805" />
    </div>;
};